type TaskFn = () => Promise<void>;

export interface IParallelTasksData {
    add: (task: TaskFn) => void;
}

/**
 * Initializes a queue into which tasks can be added for execution
 * No more than given amount of tasks will be executed at the same time
 * @param numberOfSimultaneousTasks
 */
export function parallelTasksQueue(numberOfSimultaneousTasks: number): IParallelTasksData {
    let idx = 0;

    let runningTasksCount = 0;
    const tasksData: {
        idx: number; // we don't need idx for functionality but have for testing purposes
        task: TaskFn;
    }[] = [];

    const checkNext = () => {
        if (tasksData.length && runningTasksCount < numberOfSimultaneousTasks) {
            runningTasksCount++;
            const currentTaskData = tasksData[0];
            tasksData.splice(0, 1);

            currentTaskData.task().finally(() => {
                runningTasksCount--;
                checkNext();
            });
        }
    };

    return {
        add: (task: TaskFn) => {
            let currIdx = idx++;
            tasksData.push({
                idx: currIdx,
                task: task,
            });
            checkNext();
        },
    };
}
